import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import React from 'react';
import { useTheme } from 'styled-components';
import { AppLink } from '@finect/tabular-core/AppLink';
import { getFundsCategoryPath } from '@finect/front-resources/Products';
import { StyledTable, StyledTr, StyledTh, StyledTd } from '../../../Table';
import { PercentLabel } from '../../Labels';
import { Inner } from './partials';
var TableView = function TableView(_ref) {
  var categories = _ref.categories,
    productType = _ref.productType;
  var theme = useTheme();
  return React.createElement(Inner, null, React.createElement(StyledTable, null, React.createElement("thead", null, React.createElement("tr", null, React.createElement(StyledTh, {
    left: true
  }, "Categor\xEDa"), React.createElement(StyledTh, {
    left: true
  }, "Broad"), React.createElement(StyledTh, {
    right: true
  }, productType.shortPlural), React.createElement(StyledTh, {
    right: true
  }, "Rentabilidad 12", React.createElement("br", null), "meses"), React.createElement(StyledTh, {
    right: true
  }, "Rentabilidad 36", React.createElement("br", null), "meses"))), React.createElement("tbody", null, categories.map(function (category) {
    return React.createElement(StyledTr, {
      key: category.id
    }, React.createElement(StyledTd, {
      left: true,
      style: {
        whiteSpace: 'nowrap'
      }
    }, React.createElement(AppLink, {
      href: getFundsCategoryPath(theme, productType, category)
    }, category.name)), React.createElement(StyledTd, {
      left: true,
      style: {
        whiteSpace: 'nowrap'
      }
    }, category.broad), React.createElement(StyledTd, {
      bold: true,
      right: true
    }, React.createElement(AppLink, {
      style: {
        color: 'currentColor'
      },
      href: "".concat(productType.slug, "/listado?category=").concat(category.id)
    }, category.stats.funds)), React.createElement(StyledTd, {
      right: true
    }, React.createElement(PercentLabel, {
      value: category.performance.M12 || null
    })), React.createElement(StyledTd, {
      right: true
    }, React.createElement(PercentLabel, {
      value: category.performance.M36 || null
    })));
  }))));
};
export default TableView;